import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewRacionMateriaSeca = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'racion_materia_seca',
        name: 'Racion Materia Seca',
        component: ViewRacionMateriaSeca,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
